import {Grid, Hint, LOADING, Slider, TOPIC_NEWS, WHY,} from "./getter_types";

export default {

    [WHY]: state => state.eventManagement.why,
    [Slider]: state => state.homeManagement.slider,
    [Grid]: state => state.homeManagement.grid,
    [Hint]: state => state.homeManagement.hint,
    [TOPIC_NEWS]: state => state.homeManagement.topicNews,
    [LOADING]: state => state.loading,
};
